import { atom } from '@exodus/jotai';
import { adaptersAtom } from '../core/atoms.js';
const NAMESPACE = 'headless-ui';
export function atomWithStorage(key, initialValue) {
    const baseAtom = atom(initialValue);
    baseAtom.unstable_onInit = (store) => {
        const adapters = store.get(adaptersAtom);
        if (!adapters)
            return;
        void adapters.storage
            .namespace(NAMESPACE)
            .get(key)
            .then((value) => {
            store.set(baseAtom, value ?? initialValue);
        });
    };
    return atom((get) => get(baseAtom), (get, set, update) => {
        const nextValue = update;
        set(baseAtom, nextValue);
        const adapters = get(adaptersAtom);
        if (!adapters)
            return;
        const storage = adapters.storage.namespace(NAMESPACE);
        if (nextValue === undefined) {
            void storage.delete(key);
        }
        else {
            void storage.set(key, nextValue);
        }
    });
}
